/* Endure Cool Patch — small front-end behaviors ported from the prototype:
   reveal-on-scroll + "data-buy" smooth-scroll to the buy block.
   The liquid-glass engine lives separately in liquid-glass.js. */
(function () {
  function setupReveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  function setupBuyScroll(root) {
    (root || document).querySelectorAll('[data-buy]').forEach(function (el) {
      if (el.__ecpBuy) return;
      el.__ecpBuy = true;
      el.addEventListener('click', function (e) {
        var target = document.getElementById('buy');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // Sticky header: frost it once scrolled. On mobile the bottom bar carries both
  // navigation and the cart, so the top strip is only wanted at the very top — hide it
  // the instant you scroll away and DON'T reveal it on scroll-up (that return-on-scroll-up
  // was the annoying part); it comes back only when you're back at the top. The hide is
  // CSS-gated to mobile (glass.css); desktop has no transform, so the class is a no-op there.
  function setupSticky() {
    var header = document.getElementById('site-header');
    if (!header || header.__ecpSticky) return;
    header.__ecpSticky = true;
    var ticking = false;
    function update() {
      ticking = false;
      var y = window.scrollY;
      header.classList.toggle('is-stuck', y > 16);
      header.classList.toggle('is-hidden', y > 8);   // shown only at the very top
    }
    var onScroll = function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  // Buy block: pack-size toggle swaps the add-to-cart variant + displayed price.
  function setupBuy(root) {
    (root || document).querySelectorAll('[data-packs]').forEach(function (packs) {
      if (packs.__ecpBuy) return;
      packs.__ecpBuy = true;
      var btns = [].slice.call(packs.querySelectorAll('[data-pack]'));
      var scope = packs.closest('.buy') || document;
      var input = scope.querySelector('[data-variant-input]');
      var priceEl = scope.querySelector('[data-price]');
      var totalEl = scope.querySelector('[data-cart-total]');
      var wasEl = scope.querySelector('[data-was]');
      var saveEl = scope.querySelector('[data-save]');
      function select(btn) {
        btns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        if (input) input.value = btn.getAttribute('data-variant') || '';
        var now = btn.getAttribute('data-now-display');
        if (now && priceEl) priceEl.textContent = now;
        if (now && totalEl) totalEl.textContent = now;
        var was = btn.getAttribute('data-was-display');
        var save = btn.getAttribute('data-save-display');
        if (wasEl) { wasEl.textContent = was || ''; wasEl.style.display = was ? '' : 'none'; }
        if (saveEl) { saveEl.textContent = save || ''; saveEl.style.display = save ? '' : 'none'; }
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { select(b); }); });
      var sel = packs.querySelector('[data-pack].is-selected') || btns[0];
      if (sel) select(sel);
    });
  }

  // Product page: thumbnail clicks swap the main image.
  function setupGallery(root) {
    (root || document).querySelectorAll('[data-pdp-gallery]').forEach(function (g) {
      if (g.__ecpGallery) return;
      g.__ecpGallery = true;
      var main = g.querySelector('[data-pdp-main]');
      g.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (full && main) main.src = full;
          g.querySelectorAll('[data-pdp-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  // Video section: custom player — big play/pause button + mute toggle (defaults muted).
  function setupVideo(root) {
    (root || document).querySelectorAll('[data-ecp-video]').forEach(function (wrap) {
      if (wrap.__ecpVideo) return;
      wrap.__ecpVideo = true;
      var video = wrap.querySelector('video');
      if (!video) return;
      video.muted = true;
      var playBtn = wrap.querySelector('[data-video-play]');
      var muteBtn = wrap.querySelector('[data-video-mute]');
      function syncPlay() {
        var playing = !video.paused;
        wrap.classList.toggle('is-playing', playing);
        if (playBtn) playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
      }
      function toggle() { if (video.paused) { video.play().catch(function () {}); } else { video.pause(); } }
      if (playBtn) playBtn.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
      video.addEventListener('play', syncPlay);
      video.addEventListener('pause', syncPlay);
      function syncMute() {
        wrap.classList.toggle('is-muted', video.muted);
        if (muteBtn) { muteBtn.setAttribute('aria-pressed', String(video.muted)); muteBtn.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute'); }
      }
      if (muteBtn) muteBtn.addEventListener('click', function (e) { e.stopPropagation(); video.muted = !video.muted; syncMute(); });
      syncMute(); syncPlay();
    });
  }

  ready(function () { setupReveal(document); setupBuyScroll(document); setupSticky(); setupBuy(document); setupGallery(document); setupVideo(document); });
  // Shopify theme editor re-renders sections in place:
  document.addEventListener('shopify:section:load', function (e) {
    setupReveal(e.target); setupBuyScroll(e.target); setupSticky(); setupBuy(e.target); setupGallery(e.target); setupVideo(e.target);
  });
})();
